<template>
  <div
    class="fixed-top-banner"
    :class="{ enabled: enabled, disabled: !enabled }"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "FixedTopBanner",
  props: {
    enabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>

<style scoped>
.fixed-top-banner {
  --banner-width: 60vw;
  position: fixed;
  display: flex;
  justify-content: center;
  width: var(--banner-width);
  top: 0;
  left: 50%;
  z-index: 10;
  pointer-events: all;
  opacity: 0;
}

.enabled {
  animation: fade-in-animation 0.8s forwards;
}

.disabled {
  animation: fade-out-animation 0.4s forwards;

  pointer-events: none;
}

@keyframes fade-in-animation {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(-3rem);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
}

@keyframes fade-out-animation {
  from {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
  to {
    opacity: 0;
    transform: translateX(-50%) translateY(-3rem);
  }
}
</style>
